import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { useEffect, useState } from "react";
import Errors from "../../models/errors";
import SystemNotification, {
  newSystemNotification,
} from "../../models/system-notification";
import SystemNotificationForm from "./SystemNotificationForm";

interface SystemNotificationUpdateModalProps {
  show: boolean;
  systemNotification?: SystemNotification;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SystemNotificationUpdateModal: React.FC<
  SystemNotificationUpdateModalProps
> = ({ show, systemNotification, onCancel, onSuccess }) => {
  const [initialErrors, setInitialErrors] = useState<Errors>({});
  const [initialSystemNotification, setInitialSystemNotification] =
    useState<SystemNotification>(
      systemNotification ? systemNotification : newSystemNotification()
    );

  const modalTitle = systemNotification
    ? `Editar aviso #${systemNotification.id}`
    : `Crear nuevo aviso`;

  const onClose = () => {
    setInitialErrors({});
    setInitialSystemNotification(newSystemNotification());
    onCancel();
  };

  useEffect(() => {
    setInitialSystemNotification(
      systemNotification ? systemNotification : newSystemNotification()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [systemNotification]);

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <SystemNotificationForm
            initialSystemNotification={initialSystemNotification}
            initialErrors={initialErrors}
            onCancel={onCancel}
            onSuccess={onSuccess}
          />
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default SystemNotificationUpdateModal;
